import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactGA from 'react-ga4';
import { sendWebVitalsToGoogleAnalytics } from './seo/analytics';

if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize('G-XKNP5994T6');
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <HelmetProvider>
        <Router>
            <App />
        </Router>
    </HelmetProvider>
);

if (process.env.NODE_ENV === 'production') {
    reportWebVitals(sendWebVitalsToGoogleAnalytics);
} else {
    reportWebVitals();
}
